module.exports = __webpack_public_path__ + "static/media/deepakkumarjain.f5f49740.jpg";